



















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'

/* Data types */
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

/* API */

export default Vue.extend({
  name: 'ItemDetailNavigator',

  props: {
    currentRefNumber: {
      type: Number,
      default: null,
    },
  },

  computed: {
    tooltipPlacement(): string {
      return this.$screen.isMobile(this.$mq) ? 'bottom' : 'right'
    },
    fromAll(): boolean | any {
      return BreadcrumbAssistant.fromAll(this.$route, this.$store)
    },
    fromEntityLanding(): boolean | any {
      return BreadcrumbAssistant.fromEntityLanding(this.$route, this.$store)
    },
    previousItem(): IBreadcrumbItemMenuItem {
      return BreadcrumbAssistant.getPreviousBreadcrumbItem(
        this.currentRefNumber,
        this.$store,
      )
    },
    nextItem(): IBreadcrumbItemMenuItem {
      return BreadcrumbAssistant.getNextBreadcrumbItem(
        this.currentRefNumber,
        this.$store,
      )
    },
  },
})
